import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = sessionStorage.getItem('puAccessToken');

  const defaultApiKey = environment.apimPbKey;
  const shortenApiKey = environment.shortenApimPbKey;

  const urlPath = decodeURIComponent(req.url.split('?')[0]);

  const isLoginEndpoint = urlPath.includes('/login');
  const isShortenEndpoint = /\/s(\/|$)/.test(urlPath);
  const isTokenRefreshEndpoint = urlPath.includes('/token');

  let headers = req.headers;

  // Apply correct API key
  const apiKeyToUse = isShortenEndpoint ? shortenApiKey : defaultApiKey;

  if (apiKeyToUse) {
    headers = headers.set('Ocp-Apim-Subscription-Key', apiKeyToUse);
  }

  // Set JSON content type only if not already set
  if (!headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  }

  // Attach access token only for protected endpoints
  if (token && !isLoginEndpoint && !isTokenRefreshEndpoint) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return next(req.clone({ headers }));
};
